import { useMutation } from '@tanstack/react-query'

import { reinitAllSessions } from '../../services'

import type { SessionActionResponse } from '@/modules/session/type'
import type {
	UseMutationOptions,
	UseMutationResult,
} from '@tanstack/react-query'

type UseMutationReinitAllSessionsOptions = UseMutationOptions<
	SessionActionResponse,
	Error,
	void
>

export default function useMutationReinitAllSessions(
	options?: UseMutationReinitAllSessionsOptions,
): UseMutationResult<SessionActionResponse, Error, void> {
	return useMutation({
		mutationFn: reinitAllSessions,
		...options,
	})
}
